import ErrorPage from '@/errorManagement/errorPages';
import { isWebViewFromCookie } from '@/utils/cookiesHelper';
import { DEFAULT_ERROR_MODAL_TEXT } from './constants';

function DefaultErrorPageError(props) {
  return (
    <ErrorPage
      {...props}
      iconId="circulo-x"
      iconKind="m"
      buttonText={DEFAULT_ERROR_MODAL_TEXT.BUTTON_TEXT}
      buttonHref={DEFAULT_ERROR_MODAL_TEXT.BUTTON_HREF}
      isPage={false}
      showButtons={!isWebViewFromCookie()}
    />
  );
}
export default DefaultErrorPageError;
